import axios from '@/plugins/axios'

export function getTopIndex(params = {}) {
  return axios.get('indexOpen/top', {
    params,
  })
}

export function getTodoEvent(params = {}) {
  return axios.get('indexOpen/todoEvent', {
    params,
  })
}

export function getProfitChart(params = {}) {
  return axios.get('indexOpen/profitChart', {
    params,
  })
}

export function getNewUsersChart(params = {}) {
  return axios.get('indexOpen/newUsersChart', {
    params,
  })
}

export function getNewOrderChart(params = {}) {
  return axios.get('indexOpen/newOrderChart', {
    params,
  })
}
export function getNewDayRentOrderChart(params = {}) {
  return axios.get('indexOpen/newDayRentOrderChart', {
    params,
  })
}

export function getRiddingRanking(params = {}) {
  return axios.get('indexOpen/riddingRanking', {
    params,
  })
}
export function getRiddingRankingByDayRentOrder(params = {}) {
  return axios.get('indexOpen/riddingRankingByDayRentOrder', {
    params,
  })
}

export function getBikeProfitRanking(params = {}) {
  return axios.get('indexOpen/bikeProfitRanking', {
    params,
  })
}

export function getHeatMapData(params = {}) {
  return axios.get('indexOpen/heatMap', {
    params,
  })
}

export function getAreas(params = {}) {
  return axios.get('areaOpen', {
    params,
  })
}
export function getMapBikes(params = {}) {
  return axios.get('bike/mapsOpen', {
    params,
  })
}

export function acticveWxUserSattistics(params = {}) {
  return axios.get('indexOpen/acticveWxUserSattistics', {
    params,
  })
}

export function getHourOrderNumber(params = {}) {
  return axios.get('indexOpen/hourOrderNumber', {
    params,
  })
}
export function getRecentMonthOrderProfit(params = {}) {
  return axios.get('indexOpen/recentMonthOrderProfit', {
    params,
  })
}

export function getRecentMonthAddUser(params = {}) {
  return axios.get('indexOpen/recentMonthAddUser', {
    params,
  })
}

export function getBikeStatisticsOpen(params = {}) {
  return axios.get('indexOpen/statisticsOpen', {
    params,
  })
}
